 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01COVER from '@/components/001-Cover'
 import A02TITLE from '@/components/002-Title'
 import A03DEDICATION from '@/components/003-Dedication'
 import A04COPYRIGHT from '@/components/004-Copyright'
 import A05CONTENTS from '@/components/005-Contents'
 import A07LIST_OF_MAPS from '@/components/007-List_of_Maps'
 import A08ACKNOWLEDGEMENTS from '@/components/008-Acknowledgements'
 import A091_THE_CONTEXT from '@/components/009-1_The_Context'
 import A102_X2018ABSOLUTELY_ASTONISHINGX2019_THE_WAR_COMMITTEE_AND_THE_MILITARY from '@/components/010-2_x2018Absolutely_Astonishingx2019_The_War_Committee_and_the_Military'
 import A113_DECISIONMAKING_JANUARYX2013FEBRUARY from '@/components/011-3_Decision-making_Januaryx2013February'
 import A124_DECISIONMAKING_MARCHX2013JUNE from '@/components/012-4_Decision-making_Marchx2013June'
 import A135_X2018GRASPING_AT_THE_SHADOWX2019_PLANNING_FOR_THE_SOMME_FEBRUARYX2013JUNE from '@/components/013-5_x2018Grasping_at_the_Shadowx2019_Planning_for_the_Somme_Februaryx2013June'
 import A146_X2018FAVOURABLE_RESULTS_ARE_NOT_ANTICIPATEDX2019_PREPARATIONS_FOR_BATTLE_JUNE from '@/components/014-6_x2018Favourable_Results_Are_Not_Anticipatedx2019_Preparations_for_Battle_June'
 import A157_X2018A_SHORT_LIFEX2019_VII_AND_VIII_CORPS_ON_1_JULY from '@/components/015-7_x2018A_Short_Lifex2019_VII_and_VIII_Corps_on_1_July'
 import A168_X2018THE_ENEMYX0027S_FIRE_WAS_SO_INTENSEX2019_X_CORPS_ON_1_JULY from '@/components/016-8_x2018The_Enemyx0027s_Fire_Was_So_Intensex2019_X_Corps_on_1_July'
 import A179_X2018WAVE_AFTER_WAVE_WERE_MOWN_DOWNX2019_III_CORPS_ON_1_JULY from '@/components/017-9_x2018Wave_after_Wave_Were_Mown_Downx2019_III_Corps_on_1_July'
 import A1810_X2018COWERING_MEN_IN_FIELD_GREYX2019_XV_AND_XIII_CORPS_ON_1_JULY from '@/components/018-10_x2018Cowering_Men_in_Field_Greyx2019_XV_and_XIII_Corps_on_1_July'
 import A1911_REFLECTIONS_ON_1_JULY from '@/components/019-11_Reflections_on_1_July'
 import A2012_X2018ILLCONSIDERED_ATTACKS_ON_A_SMALL_FRONTX2019_2X201313_JULY from '@/components/020-12_x2018Ill-Considered_Attacks_on_a_Small_Frontx2019_2x201313_July'
 import A2113_X2018CAVALRY_SHARPENING_THEIR_SWORDSX2019_14_JULY from '@/components/021-13_x2018Cavalry_Sharpening_Their_Swordsx2019_14_July'
 import A2214_X2018WE_ARE_A_BIT_STUCKX2019_15X201331_JULY from '@/components/022-14_x2018We_Are_a_Bit_Stuckx2019_15x201331_July'
 import A2315_X2018SOMETHING_WANTING_IN_THE_METHODS_EMPLOYEDX2019_1_AUGUSTX201312_SEPTEMBER from '@/components/023-15_x2018Something_Wanting_in_the_Methods_Employedx2019_1_Augustx201312_September'
 import A2416_X2018A_HELL_OF_A_TIMEX2019_POZIX00E8RES_AND_MOUQUET_FARM_JULYX2013AUGUST from '@/components/024-16_x2018A_Hell_of_a_Timex2019_Pozix00E8res_and_Mouquet_Farm_Julyx2013August'
 import A2517_SUMMARY_15_JULYX201312_SEPTEMBER from '@/components/025-17_Summary_15_Julyx201312_September'
 import A2618_THE_POLITICIANS_AND_THE_SOMME_CAMPAIGN_JULYX2013AUGUST from '@/components/026-18_The_Politicians_and_the_Somme_Campaign_Julyx2013August'
 import A2719_ONE_DIVISIONX0027S_SOMME_THE_FIRST_DIVISION_JULYX2013SEPTEMBER from '@/components/027-19_One_Divisionx0027s_Somme_The_First_Division_Julyx2013September'
 import A2820_X2018AN_OPERATION_PLANNED_ON_BOLDER_LINESX2019_TANKS_AND_THE_15_SEPTEMBER_PLAN from '@/components/028-20_x2018An_Operation_Planned_on_Bolder_Linesx2019_Tanks_and_the_15_September_Plan'
 import A2921_LUMBERING_TANKS_THE_BATTLE_OF_15_SEPTEMBER from '@/components/029-21_Lumbering_Tanks_The_Battle_of_15_September'
 import A3022_25_SEPTEMBER from '@/components/030-22_25_September'
 import A3123_X2018THE_TRAGIC_HILL_OF_THIEPVALX2019_26X201330_SEPTEMBER from '@/components/031-23_x2018The_Tragic_Hill_of_Thiepvalx2019_26x201330_September'
 import A3224_X2018A_SEVERE_TRIAL_OF_BODY_AND_SPIRITX2019_THE_SOMME_OCTOBER from '@/components/032-24_x2018A_Severe_Trial_of_Body_and_Spiritx2019_The_Somme_October'
 import A3325_X2018WE_MUST_KEEP_GOINGX2019_THE_POLITICIANS_AND_THE_SOMME_CAMPAIGN_SEPTEMBERX2013OCTOBER from '@/components/033-25_x2018We_Must_Keep_Goingx2019_The_Politicians_and_the_Somme_Campaign_Septemberx2013October'
 import A3426_THE_POLITICAL_BATTLE_BEAUMONT_HAMEL_13X201319_NOVEMBER from '@/components/034-26_The_Political_Battle_Beaumont_Hamel_13x201319_November'
 import A3527_REFLECTIONS_ON_THE_BRITISH_AT_THE_SOMME from '@/components/035-27_Reflections_on_the_British_at_the_Somme'
 import A3628_EPILOGUE_THE_END_OF_IT_ALL_NOVEMBER_1916 from '@/components/036-28_Epilogue_The_End_of_It_All_November_1916'
 import A37NOTES from '@/components/037-Notes'
 import A38BIBLIOGRAPHY from '@/components/038-Bibliography'
 import A39INDEX from '@/components/039-Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/005-Contents",
 			"name" : "005-Contents",
 			"component" : A05CONTENTS
 		},
 		{
 			"path" : "/007-List_of_Maps",
 			"name" : "007-List_of_Maps",
 			"component" : A07LIST_OF_MAPS
 		},
 		{
 			"path" : "/008-Acknowledgements",
 			"name" : "008-Acknowledgements",
 			"component" : A08ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/009-1_The_Context",
 			"name" : "009-1_The_Context",
 			"component" : A091_THE_CONTEXT
 		},
 		{
 			"path" : "/010-2_x2018Absolutely_Astonishingx2019_The_War_Committee_and_the_Military",
 			"name" : "010-2_x2018Absolutely_Astonishingx2019_The_War_Committee_and_the_Military",
 			"component" : A102_X2018ABSOLUTELY_ASTONISHINGX2019_THE_WAR_COMMITTEE_AND_THE_MILITARY
 		},
 		{
 			"path" : "/011-3_Decision-making_Januaryx2013February",
 			"name" : "011-3_Decision-making_Januaryx2013February",
 			"component" : A113_DECISIONMAKING_JANUARYX2013FEBRUARY
 		},
 		{
 			"path" : "/012-4_Decision-making_Marchx2013June",
 			"name" : "012-4_Decision-making_Marchx2013June",
 			"component" : A124_DECISIONMAKING_MARCHX2013JUNE
 		},
 		{
 			"path" : "/013-5_x2018Grasping_at_the_Shadowx2019_Planning_for_the_Somme_Februaryx2013June",
 			"name" : "013-5_x2018Grasping_at_the_Shadowx2019_Planning_for_the_Somme_Februaryx2013June",
 			"component" : A135_X2018GRASPING_AT_THE_SHADOWX2019_PLANNING_FOR_THE_SOMME_FEBRUARYX2013JUNE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js